<template>
    <div>
        <div class="page-title">超级管理员信息</div>
        
        <pay-box title="超级管理员信息" v-if="!ready">
            <p>请先完成主体资料填写</p>
            <a @click="changeStep(3)">立即前往</a>
        </pay-box>
        <template v-else>
            
            <pay-box title="超级管理员信息"
                     sub-title="超级管理员将接收开户信息及完成签约，并可进行商户号的日常重要管理及资金操作。">
                
                
                <div class="pay-apply-item">
                    
                    <div class="pay-apply-item-title">超管身份</div>
                    
                    <div class="pay-apply-item-content" v-if="applyManager.isPerson()">
                        法人/经营者
                    </div>
                    
                    <div class="pay-apply-item-content" v-else>
                        
                        <a-radio-group v-model="params.contact_info.contact_type" @change="typeChange">
                            <a-radio-button value="65">法人/经营者</a-radio-button>
                            <a-radio-button value="66">经办人</a-radio-button>
                        </a-radio-group>
                    
                    </div>
                
                </div>
                
                
                <div class="pay-apply-item">
                    
                    <div class="pay-apply-item-title">超管姓名</div>
                    
                    <div class="pay-apply-item-content" v-if="params.contact_info.contact_type === '65' ">
                        {{ params.contact_info.contact_name }}
                    </div>
                    <div class="pay-apply-item-content" v-else>
                        <at-input v-model="params.contact_info.contact_name" class="pay-apply-input"/>
                    </div>
                
                </div>
                
                <div class="pay-apply-item">
                    
                    <div class="pay-apply-item-title">手机号码</div>
                    
                    <div class="pay-apply-item-content">
                        <at-input v-model="params.contact_info.mobile_phone" unit="+86" class="pay-apply-input"/>
                    </div>
                
                </div>
                
                <div class="pay-apply-tips">用于接收微信支付的重要管理信息及日常操作验证码</div>
            
            </pay-box>
            
            <pay-box title="超级管理员证件" v-if="params.contact_info.contact_type === '66' ">
                <div class="pay-apply-item has-tips">
                    
                    <div class="pay-apply-item-title">身份证人像面照片</div>
                    
                    <div class="pay-apply-item-content">
                        <div class="thumb-img">
                            
                            <upload-image
                                v-model="params.contact_info.img_a_url"
                                :action="applyManager.uploadIdCardAUrl"
                                :done="idCardADone"
                                class="pay-apply-upload"
                            ></upload-image>
                        
                        </div>
                    </div>
                </div>
                
                <div class="pay-apply-item has-tips">
                    
                    <div class="pay-apply-item-title">身份证国徽面照片</div>
                    
                    <div class="pay-apply-item-content">
                        <div class="thumb-img">
                            
                            <upload-image
                                v-model="params.contact_info.img_b_url"
                                :action="applyManager.uploadIdCardBUrl"
                                :done="idCardBDone"
                                class="pay-apply-upload"
                            />
                        
                        </div>
                    </div>
                </div>
                
                <div class="pay-apply-tips">请上传彩色照片 or 彩色扫描件 or
                    加盖公章鲜章的复印件，可添加“微信支付”相关水印（如微信支付认证）
                </div>
                
                <div class="pay-apply-item">
                    
                    <div class="pay-apply-item-title">身份证件号码</div>
                    
                    <div class="pay-apply-item-content">
                        <at-input v-model="params.contact_info.contact_id_card_number" class="pay-apply-input"/>
                    </div>
                
                </div>
                
                <div class="pay-apply-item">
                    
                    <div class="pay-apply-item-title">证件有效期类型</div>
                    
                    <div class="pay-apply-item-content">
                        
                        <a-radio-group @change="idCardTypeChanged" v-model="idCardType">
                            <a-radio :value="1">定期</a-radio>
                            <a-radio :value="2">长期</a-radio>
                        </a-radio-group>
                    
                    </div>
                
                </div>
                
                <div class="pay-apply-item">
                    
                    <div class="pay-apply-item-title">证件生效日期</div>
                    
                    <div class="pay-apply-item-content">
                        
                        <a-date-picker
                            v-model="params.contact_info.contact_id_doc_period_begin"
                            class="date-picker pay-apply-input"
                            format="YYYY-MM-DD"
                            placeholder="选择日期"
                        ></a-date-picker>
                    
                    </div>
                
                </div>
                
                <div class="pay-apply-item" v-if=" idCardType === 1 ">
                    
                    <div class="pay-apply-item-title">证件失效日期</div>
                    
                    <div class="pay-apply-item-content">
                        
                        <a-date-picker
                            v-model="params.contact_info.contact_id_doc_period_end"
                            class="date-picker pay-apply-input"
                            format="YYYY-MM-DD"
                            placeholder="选择日期"
                        ></a-date-picker>
                    
                    </div>
                
                </div>
                
                <div class="pay-apply-item has-tips">
                    
                    <div class="pay-apply-item-title">业务办理授权函</div>
                    
                    <div class="pay-apply-item-content">
                        <div class="thumb-img">
                            
                            <upload-image
                                v-model="params.contact_info.letter_url"
                                :action="applyManager.uploadMediaUrl"
                                :done="letterDone"
                                class="pay-apply-upload"
                            />
                        
                        </div>
                    </div>
                </div>
                
                <div class="pay-apply-tips">
                    1、当超级管理员类型是经办人时，请上传业务办理授权函。 <br>
                    2、请参照 <a href="https://kf.qq.com/faq/220509Y3Yvym220509fQvYR7.html">示例图</a>
                    打印业务办理授权函，全部信息需打印，不支持手写商户信息，并加盖公章。
                </div>
            
            </pay-box>
        
        </template>
        
        <div class="pay-apply-btns">
            <button @click="saveChange(2)" class="btn btn-white">返回</button>
            <button @click="saveChange(2)" class="btn">下一步</button>
        </div>
    
    </div>
</template>

<script>
import PayBox from "./PayBox";
import AtInput from "../../../../components/AtInput";
import api from "../../../../repo/api";
import ecApply from "@/store/ec-apply";
import UploadImage from "@/components/UploadImage.vue";

export default {
    name: "Step6",
    components: {UploadImage, AtInput, PayBox},
    props: {
        apply: Object
    },
    data() {
        return {
            idCardType: 1,
            ready: false,
            params: {
                contact_info: {
                    contact_name: '',
                    mobile_phone: '',
                    contact_type: '65',
                    contact_id_card_number: "",
                    contact_id_doc_copy: "",
                    contact_id_doc_copy_back: "",
                    contact_id_doc_period_begin: "",
                    contact_id_doc_period_end: "",
                    business_authorization_letter: "",
                    img_a_url: "",
                    img_b_url: "",
                    letter_url: ""
                }
            },
            applyManager: ecApply,
        }
    },
    mounted() {
        
        let info = this.applyManager.getApplyValue('id_card_info')
        
        if (!info) return
        
        this.params.contact_info = this.applyManager.getApplyValue('contact_info', this.params.contact_info)
        
        this.loadContactName()
        
        this.ready = true
    },
    methods: {
        idCardADone(res) {
            this.params.contact_info.contact_id_doc_copy = res['media_id']
            this.params.contact_info.img_a_url = res['img_url']
            this.params.contact_info.contact_id_card_number = res['id']
        },
        idCardBDone(res) {
            this.params.contact_info.contact_id_doc_copy_back = res['media_id']
            this.params.contact_info.img_b_url = res['img_url']
            this.params.contact_info.contact_id_doc_period_begin = res['date_begin']
            this.params.contact_info.contact_id_doc_period_end = res['date_end']
            
            this.idCardType = res['date_end'] === '长期' ? 2 : 1
        },
        letterDone(res) {
            this.params.contact_info.letter_url = res['img_url']
            this.params.contact_info.business_authorization_letter = res['media_id']
        },
        idCardTypeChanged(val) {
            this.params.contact_info.contact_id_doc_period_end = val === 1 ? '' : '长期'
        },
        changeStep(step) {
            this.applyManager.gotoStep(step)
        },
        typeChange() {
            this.loadContactName()
        },
        loadContactName() {
            if (this.params.contact_info.contact_type !== '65') return
            
            this.params.contact_info.contact_name = this.applyManager.getApplyValue('id_card_info.id_card_name')
        },
        saveChange(step) {
            
            if (!this.ready) return this.changeStep(step)
            
            this.$loading.show()
            
            const params = {...this.params.contact_info}
            
            if (params.contact_type === '65') {
                delete params.contact_id_card_number
                delete params.contact_id_doc_copy
                delete params.contact_id_doc_copy_back
                delete params.contact_id_doc_period_begin
                delete params.contact_id_doc_period_end
                delete params.business_authorization_letter
                delete params.img_a_url
                delete params.img_b_url
                delete params.letter_url
            }
            
            
            api.post('/ec-pay-apply/save-contact-info', this.params, (data) => {
                
                this.$loading.hide()
                
                if (data.code !== 0) this.$message.data(data)
                
                if (data.code === 0) {
                    this.applyManager.gotoStep(step, data.data)
                }
                
            })
        }
    },
}
</script>

<style scoped>

</style>